<template>
  <div class="tile is-parent is-vertical">
    <div class="tile is-child">
      <div class>
        <div class>
          <section class>
            <section id="entity-content" class>
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification formbox">
                  <b-tabs>
                    <b-tab-item label="Meu Perfil">
                      <div>
                        <img src="../../assets/images/icon-color/user.svg" class="profile-photo" />
                        <span class="profile-name-a">{{ usuario.name }}</span>
                        <span class="profile-job-a">{{ usuario.cargo }}</span>
                      </div>
                      <div class="profile-informations">
                        <ul>
                          <li>
                            E-Mail:
                            <span class="profile-infos-span">{{ usuario.email}}</span>
                          </li>
                          <li>
                            Telefone/Celular:
                            <span class="profile-infos-span" v-mask="">{{ usuario.telefone }}</span>
                          </li>
                          <li>
                            Data de Nascimento:
                            <span
                              class="profile-infos-span"
                            >{{ formatData(usuario.nascimento, 'DD/MM/YYYY') }}</span>
                          </li>
                        </ul>
                      </div>
                    </b-tab-item>
                  </b-tabs>
                </article>
              </div>
            </section>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mostrar: true
    };
  },
  props: ["usuario"]
};
</script>